import { __rest } from "tslib";
import React, { useContext } from 'react';
import classNames from 'classnames';
import Icon from '@vtblife/uikit-icons';
import useSlots from '../../hooks/use-slots';
import { context, openedContext } from './utils';
import s from './title.module.css';
import { Badge as BadgeBase } from '../badge/index';
var icons = {
  chevron: ['chevron-down', 'chevron-down'],
  plus: ['plus-circle', 'minus-circle']
};
export var Title = function Title(_ref) {
  var children = _ref.children,
    itemProp = _ref.itemProp,
    itemScope = _ref.itemScope,
    itemType = _ref.itemType;
  var selected = useContext(openedContext);
  var _useContext = useContext(context),
    icon = _useContext.icon,
    size = _useContext.size;
  var slots = useSlots('Collapse.Title', children);
  var glyphName = icon && icons[icon][0 + Number(selected)];
  return React.createElement("div", {
    className: classNames(s.box, s[size], selected && s.selected)
  }, React.createElement("div", {
    className: s.wrapper
  }, React.createElement("div", Object.assign({
    className: classNames(s.content, !slots.addon && s.single)
  }, {
    itemProp: itemProp,
    itemScope: itemScope,
    itemType: itemType
  }), React.createElement("div", {
    className: s.text
  }, slots.children), slots.badge && React.createElement("div", {
    className: s.badge
  }, slots.badge), glyphName && React.createElement("div", {
    className: classNames(s.icon, icon === 'chevron' && s.flippable)
  }, React.createElement(Icon, {
    name: glyphName,
    size: size === 'l' ? 'm' : 's'
  })))), slots.addon);
};
Title.slot = 'Collapse:title';
export var Badge = function Badge(_a) {
  var children = _a.children,
    color = _a.color,
    props = __rest(_a, ["children", "color"]);
  return React.createElement(BadgeBase, Object.assign({
    color: color || 'green'
  }, props, {
    size: "s"
  }), children);
};
Badge.slot = 'Collapse.Title:badge';
export var TitleAddon = function TitleAddon(_ref2) {
  var children = _ref2.children;
  return React.createElement("div", {
    className: s.addon
  }, children);
};
TitleAddon.slot = 'Collapse.Title:addon';